import GenericTableResponse from "@/models/api/GenericTableResponse";
import { COST_DOCUMENT_STATUSES } from "@/static/costDocumentStatuses";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsString, ValidateNested } from "class-validator";

export class CostDocumentOther {
  @IsString()
  @Expose()
  id!: string;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  receiptDate!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsBoolean()
  @Expose()
  isEditingLocked!: boolean;
  @IsEnum(COST_DOCUMENT_STATUSES)
  @Expose()
  status!: COST_DOCUMENT_STATUSES;
}

export class CostDocumentOtherResponse extends GenericTableResponse<CostDocumentOther> {
  @Type(() => CostDocumentOther)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CostDocumentOther>;
}

export class CostDocumentOtherFiltered {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
}
